module.exports = __webpack_public_path__ + "img/the-anarchist--edited.f8cddd8b.webp";